import { ClientEnvironment } from 'src/app/endpoints-config/models/endpoints-config';
import { environment } from 'src/environments/environment';

export const CLIENT_ENV_AUTH: ClientEnvironment = {
    authenticationUrl: '',
    portalApiUrl: environment.webApiServerEndpoint,
    coreUiUrl: '/core-api',
    sharedUiUrl: '/share-pai'
};